import { TextEngravingElement } from 'src/api/models/Elements/Element/TextEngravingElement'
import { SnapshotIn } from 'mobx-state-tree'
import { Project as ProjectModel } from 'src/api/models/Project'
import { fontNames } from 'src/constants/font'
import { ElementEdge as ElementEdgeModel } from 'src/api/models/Elements/ElementEdge'
import { v4 as uuid } from 'uuid'
import { toGlobalId } from '../utils/globalId'

export const id = toGlobalId('Project', 'default')

const someValue = (factor = 10) => Math.round(Math.random() * factor)

type ElementEdge = SnapshotIn<ReturnType<typeof ElementEdgeModel>>

const elementEdge = (from = uuid()): Omit<ElementEdge, 'node'> => ({
  __typename: 'ElementEdge' as const,
  properties: {
    offset: {
      x: { value: someValue(Math.random() > 0.5 ? -20 : 20) },
      y: { value: someValue(Math.random() > 0.5 ? -20 : 20) }
    }
  }
})
const circularClipping = (from: string): ElementEdge => ({
  ...elementEdge(from),
  node: {
    __typename: 'CircularClippingElement' as const,
    properties: {
      radius: { value: someValue() }
    }
  }
})

const circularEngraving = (from: string): ElementEdge => ({
  ...elementEdge(from),
  node: {
    __typename: 'CircularEngravingElement',
    properties: {
      style: {
        value: Math.random() > 0.5 ? ('stroke' as const) : ('fill' as const)
      },
      radius: { value: 10 }
    }
  }
})

const rectangularEngraving = (from?: string): ElementEdge => ({
  ...elementEdge(from),
  node: {
    __typename: 'RectangularEngravingElement' as const,
    properties: {
      style: {
        value: Math.random() > 0.5 ? ('stroke' as const) : ('fill' as const)
      },
      width: { value: someValue() },
      height: { value: someValue() }
    }
  }
})

const rectangularClipping = (from?: string): ElementEdge => ({
  ...elementEdge(from),
  node: {
    __typename: 'RectangularClippingElement' as const,
    properties: {
      width: { value: someValue() },
      height: { value: someValue() }
    }
  }
})

const textEngraving = (from?: string): ElementEdge => ({
  ...elementEdge(from),
  node: {
    __typename: 'TextEngravingElement' as const,
    properties: {
      style: {
        value: Math.random() > 0.5 ? ('stroke' as const) : ('fill' as const)
      },
      font: fontNames[Math.floor(Math.random() * fontNames.length)],
      fontSize: { value: 5 },
      text: {
        value:
          Math.random() > 0.5
            ? 'BOXTRONIK'
            : Math.random() > 0.5
            ? 'Lorem Ipsum'
            : 'Omne Animal'
      }
    }
  } as SnapshotIn<typeof TextEngravingElement>
})

const testElements = () =>
  [
    textEngraving,
    Math.random() > 0.5 ? circularClipping : rectangularClipping,
    Math.random() < 0.5 ? circularClipping : rectangularClipping,
    Math.random() > 0.5 ? circularEngraving : rectangularEngraving,
    Math.random() < 0.5 ? circularEngraving : rectangularEngraving
  ].map((fn) =>
    fn('QWRhcHRlcjplMzU3NzlkZS0yMTM0LTQ3YWQtYjFhMS0zYWJjNzJiYzI2MDA')
  )

const testData: SnapshotIn<ReturnType<typeof ProjectModel>> = {
  id,
  properties: {
    name: { value: 'Default' },
    description: { value: 'Lots of nice Elements in here' }
  },
  content: {
    edges: [
      {
        __typename: 'ContentEdge',
        node: {
          properties: {
            width: {
              value: 160,
              unit: 'mm'
            },
            length: {
              value: 100,
              unit: 'mm'
              // __typename: 'Length'
            },
            thickness: {
              value: 1.55,
              unit: 'mm'
              // __typename: 'Thickness'
            },
            componentSide: {
              height: {
                value: 24,
                unit: 'mm'
                // __typename: 'Height'
              },
              border: {
                top: {
                  value: 3,
                  unit: 'mm'
                  // __typename: 'BorderSide'
                },
                right: {
                  value: 0,
                  unit: 'mm'
                  // __typename: 'BorderSide'
                },
                bottom: {
                  value: 3,
                  unit: 'mm'
                  // __typename: 'BorderSide'
                },
                left: {
                  value: 0,
                  unit: 'mm'
                  // __typename: 'BorderSide'
                }
                // __typename: 'Border'
              }
            },
            solderSide: {
              height: {
                value: 5,
                unit: 'mm'
                // __typename: 'Height'
              },
              border: {
                top: {
                  value: 3,
                  unit: 'mm'
                  // __typename: 'BorderSide'
                },
                right: {
                  value: 0,
                  unit: 'mm'
                  // __typename: 'BorderSide'
                },
                bottom: {
                  value: 3,
                  unit: 'mm'
                  // __typename: 'BorderSide'
                },
                left: {
                  value: 0,
                  unit: 'mm'
                }
                // __typename: 'Border'
              }
            }

            // __typename: 'PrintedcircuitboardProperties'
          },
          __typename: 'Printedcircuitboard'
        }
      }
    ],
    __typename: 'ContentConnection'
  },
  // enclosure: {
  //   adapterEdges: [
  //     {
  //       // from: 'UHJvamVjdDozZDhkZjhhNS0yYzRmLTRmODEtODRmMC05M2IyN2M1NGU1ZWE=',
  //       id: 'QWRhcHRlckVkZ2U6YTU2ZGNiZDctOWNiZC00NWI3LWIzZGYtODAzZGMwZWNjZmJk',
  //       // to: 'QWRhcHRlcjplMzU3NzlkZS0yMTM0LTQ3YWQtYjFhMS0zYWJjNzJiYzI2MDA=',
  //       __typename: 'AdapterEdge',
  //       node: {
  //         id: 'QWRhcHRlcjplMzU3NzlkZS0yMTM0LTQ3YWQtYjFhMS0zYWJjNzJiYzI2MDA=',
  //         __typename: 'Adapter',
  //         plates: {
  //           edges: [
  //             {
  //               // from: 'QWRhcHRlcjplMzU3NzlkZS0yMTM0LTQ3YWQtYjFhMS0zYWJjNzJiYzI2MDA=',
  //               id:
  //                 'QWRhcHRlclBsYXRlRWRnZTo2NmZkMjlkMy03NmE4LTQwMzQtYTdiNC1iZjk3NDk4NTE1OTM=',
  //               // to: 'QWRhcHRlclBsYXRlOjBhZmUzYTkxLTNkMjItNDcyYS05NDIyLWFhZTkwZmI0MGExNg==',
  //               properties: {
  //                 side: 'top'
  //                 // __typename: 'AdapterPlateEdgeProperties'
  //               },
  //               __typename: 'AdapterPlateEdge',
  //               node: {
  //                 id:
  //                   'QWRhcHRlclBsYXRlOjBhZmUzYTkxLTNkMjItNDcyYS05NDIyLWFhZTkwZmI0MGExNg==',
  //                 properties: {
  //                   //   width: {
  //                   //     // value: 0,
  //                   //     // unit: 'mm',
  //                   //     // __typename: 'Width'
  //                   //   },
  //                   //   length: {
  //                   //     value: 0,
  //                   //     unit: 'mm',
  //                   //     __typename: 'Length'
  //                   //   },
  //                   // thickness: {
  //                   //   value: 8,
  //                   //   unit: 'mm'
  //                   //   // __typename: 'Thickness'
  //                   // }
  //                   //   __typename: 'AdapterPlateProperties'
  //                 },
  //                 elements: {
  //                   edges: [],
  //                   __typename: 'ElementConnection'
  //                 },
  //                 __typename: 'AdapterPlate'
  //               }
  //             },
  //             {
  //               // from: 'QWRhcHRlcjplMzU3NzlkZS0yMTM0LTQ3YWQtYjFhMS0zYWJjNzJiYzI2MDA=',
  //               id:
  //                 'QWRhcHRlclBsYXRlRWRnZTo0ZTQ2ZDUxYi1jZjg4LTRmMmQtOGFkYi1jM2M2YmQyM2NiMmY=',
  //               // to: 'QWRhcHRlclBsYXRlOjgwMDA2YjRkLWQ3YzYtNDcxYy05N2M4LWU3YTc1NDA0MDk5MA==',
  //               properties: {
  //                 side: 'bottom',
  //                 __typename: 'AdapterPlateEdgeProperties'
  //               },
  //               __typename: 'AdapterPlateEdge',
  //               node: {
  //                 id:
  //                   'QWRhcHRlclBsYXRlOjgwMDA2YjRkLWQ3YzYtNDcxYy05N2M4LWU3YTc1NDA0MDk5MA==',
  //                 properties: {
  //                   // width: {
  //                   //   value: 0,
  //                   //   unit: 'mm',
  //                   //   __typename: 'Width'
  //                   // },
  //                   // length: {
  //                   //   value: 0,
  //                   //   unit: 'mm',
  //                   //   __typename: 'Length'
  //                   // },
  //                   // thickness: {
  //                   //   value: 8,
  //                   //   unit: 'mm'
  //                   //   // __typename: 'Thickness'
  //                   // },
  //                   __typename: 'AdapterPlateProperties'
  //                 },
  //                 elements: {
  //                   edges: [],
  //                   __typename: 'ElementConnection'
  //                 },
  //                 __typename: 'AdapterPlate'
  //               }
  //             }
  //           ],
  //           __typename: 'AdapterPlateConnection'
  //         }
  //       }
  //     }
  //   ],
  //   coverEdges: [
  //     {
  //       // from: 'UHJvamVjdDozZDhkZjhhNS0yYzRmLTRmODEtODRmMC05M2IyN2M1NGU1ZWE=',
  //       id: 'Q292ZXJFZGdlOmU5MmFiYzdmLTI0MjMtNDViOS04YzE1LTA0ZjczMTdmZWNjOQ==',
  //       // to: 'Q292ZXI6ZmQyMTE1MzUtYjAxYS00NjdlLTg2ZjItNmM3NWE1YWQ4Mzhh',
  //       __typename: 'CoverEdge',
  //       node: {
  //         id: 'Q292ZXI6ZmQyMTE1MzUtYjAxYS00NjdlLTg2ZjItNmM3NWE1YWQ4Mzhh',
  //         color: 'orange',
  //         __typename: 'Cover',
  //         plates: {
  //           edges: [
  //             {
  //               // from: 'Q292ZXI6ZmQyMTE1MzUtYjAxYS00NjdlLTg2ZjItNmM3NWE1YWQ4Mzhh',
  //               id:
  //                 'Q292ZXJQbGF0ZUVkZ2U6MWY5NGI5ODQtNzNiNy00MjAyLTg3NjctMTE4NzQzZDhlZWYy',
  //               // to: 'Q292ZXJQbGF0ZTo0NjI4ZDg0Zi03MzU0LTQzYTQtYjMwMS0zNzEyNzdmODM2MWU=',
  //               properties: {
  //                 side: 'top',
  //                 __typename: 'CoverPlateEdgeProperties'
  //               },
  //               __typename: 'CoverPlateEdge',
  //               node: {
  //                 id:
  //                   'Q292ZXJQbGF0ZTo0NjI4ZDg0Zi03MzU0LTQzYTQtYjMwMS0zNzEyNzdmODM2MWU=',
  //                 properties: {
  //                   // width: {
  //                   //   value: 0,
  //                   //   unit: 'mm',
  //                   //   __typename: 'Width'
  //                   // },
  //                   // length: {
  //                   //   value: 0,
  //                   //   unit: 'mm',
  //                   //   __typename: 'Length'
  //                   // },
  //                   thickness: {
  //                     value: 3,
  //                     unit: 'mm'
  //                     // __typename: 'Thickness'
  //                   },
  //                   // color: 'green',
  //                   __typename: 'CoverPlateProperties'
  //                 },
  //                 elements: {
  //                   edges: testElements(),
  //                   __typename: 'ElementConnection'
  //                 },
  //                 __typename: 'CoverPlate'
  //               }
  //             },
  //             {
  //               // from: 'Q292ZXI6ZmQyMTE1MzUtYjAxYS00NjdlLTg2ZjItNmM3NWE1YWQ4Mzhh',
  //               id:
  //                 'Q292ZXJQbGF0ZUVkZ2U6ZTlhZTZmODItMDc2ZS00MTZlLWFjMTktYmJhYTdhNDBiNzY1',
  //               // to: 'Q292ZXJQbGF0ZToxOGRhNjg2Yi1mNzQ2LTQ3ZmYtOWQ4Mi00MjBiYmVkNTNlOGY=',
  //               properties: {
  //                 side: 'right',
  //                 __typename: 'CoverPlateEdgeProperties'
  //               },
  //               __typename: 'CoverPlateEdge',
  //               node: {
  //                 id:
  //                   'Q292ZXJQbGF0ZToxOGRhNjg2Yi1mNzQ2LTQ3ZmYtOWQ4Mi00MjBiYmVkNTNlOGY=',
  //                 properties: {
  //                   // width: {
  //                   //   value: 0,
  //                   //   unit: 'mm',
  //                   //   __typename: 'Width'
  //                   // },
  //                   // length: {
  //                   //   value: 0,
  //                   //   unit: 'mm',
  //                   //   __typename: 'Length'
  //                   // },
  //                   thickness: {
  //                     value: 3,
  //                     unit: 'mm'
  //                     // __typename: 'Thickness'
  //                   },
  //                   // color: 'green',
  //                   __typename: 'CoverPlateProperties'
  //                 },
  //                 elements: {
  //                   edges: testElements(),
  //                   __typename: 'ElementConnection'
  //                 },

  //                 __typename: 'CoverPlate'
  //               }
  //             },
  //             {
  //               // from: 'Q292ZXI6ZmQyMTE1MzUtYjAxYS00NjdlLTg2ZjItNmM3NWE1YWQ4Mzhh',
  //               id:
  //                 'Q292ZXJQbGF0ZUVkZ2U6MDUyOTExZjktZDE3MS00NTJiLWE5MGItYWYwMWEzYjk3ZGZl',
  //               // to: 'Q292ZXJQbGF0ZTo3NDhiODQ3ZS0yZDMzLTRmYjYtYTA5YS1kYWY5YjRlMzEyZTc=',
  //               properties: {
  //                 side: 'bottom',
  //                 __typename: 'CoverPlateEdgeProperties'
  //               },

  //               __typename: 'CoverPlateEdge',
  //               node: {
  //                 id:
  //                   'Q292ZXJQbGF0ZTo3NDhiODQ3ZS0yZDMzLTRmYjYtYTA5YS1kYWY5YjRlMzEyZTc=',
  //                 properties: {
  //                   // width: {
  //                   //   value: 0,
  //                   //   unit: 'mm',
  //                   //   __typename: 'Width'
  //                   // },
  //                   // length: {
  //                   //   value: 0,
  //                   //   unit: 'mm',
  //                   //   __typename: 'Length'
  //                   // },
  //                   thickness: {
  //                     value: 3,
  //                     unit: 'mm'
  //                     // __typename: 'Thickness'
  //                   },
  //                   // color: 'GREEN',
  //                   __typename: 'CoverPlateProperties'
  //                 },
  //                 elements: {
  //                   edges: testElements(),
  //                   __typename: 'ElementConnection'
  //                 },

  //                 __typename: 'CoverPlate'
  //               }
  //             },
  //             {
  //               // from: 'Q292ZXI6ZmQyMTE1MzUtYjAxYS00NjdlLTg2ZjItNmM3NWE1YWQ4Mzhh',
  //               id:
  //                 'Q292ZXJQbGF0ZUVkZ2U6Y2Q5MDExM2ItODI2Ny00ZDQyLWE3ZWYtNmRmOGI2NTllY2Nm',
  //               // to: 'Q292ZXJQbGF0ZTo0NTQ0ZjIwNi0yMjY4LTRjZTEtOTQ2NS03MDIxMDU0ZjBlNDk=',
  //               properties: {
  //                 side: 'left',
  //                 __typename: 'CoverPlateEdgeProperties'
  //               },
  //               __typename: 'CoverPlateEdge',
  //               node: {
  //                 id:
  //                   'Q292ZXJQbGF0ZTo0NTQ0ZjIwNi0yMjY4LTRjZTEtOTQ2NS03MDIxMDU0ZjBlNDk=',
  //                 properties: {
  //                   // width: {
  //                   //   value: 0,
  //                   //   unit: 'mm',
  //                   //   __typename: 'Width'
  //                   // },
  //                   // length: {
  //                   //   value: 0,
  //                   //   unit: 'mm',
  //                   //   __typename: 'Length'
  //                   // },
  //                   thickness: {
  //                     value: 3,
  //                     unit: 'mm'
  //                     // __typename: 'Thickness'
  //                   },
  //                   // color: 'GREEN',
  //                   __typename: 'CoverPlateProperties'
  //                 },
  //                 elements: {
  //                   edges: testElements(),
  //                   __typename: 'ElementConnection'
  //                 },
  //                 __typename: 'CoverPlate'
  //               }
  //             },
  //             {
  //               // from: 'Q292ZXI6ZmQyMTE1MzUtYjAxYS00NjdlLTg2ZjItNmM3NWE1YWQ4Mzhh',
  //               id:
  //                 'Q292ZXJQbGF0ZUVkZ2U6OTMzMzM0NmItMDQ4Yi00ZDhlLWEzZmYtOWQzNjVlMDIxYTQy',
  //               // to: 'Q292ZXJQbGF0ZTo0NWQzYjBkMC0zYTkwLTRlZDUtYjhkMS1iYTE2M2QwNzYzNTA=',
  //               properties: {
  //                 side: 'front',
  //                 __typename: 'CoverPlateEdgeProperties'
  //               },

  //               __typename: 'CoverPlateEdge',
  //               node: {
  //                 id:
  //                   'Q292ZXJQbGF0ZTo0NWQzYjBkMC0zYTkwLTRlZDUtYjhkMS1iYTE2M2QwNzYzNTA=',
  //                 properties: {
  //                   // width: {
  //                   //   value: 0,
  //                   //   unit: 'mm',
  //                   //   __typename: 'Width'
  //                   // },
  //                   // length: {
  //                   //   value: 0,
  //                   //   unit: 'mm',
  //                   //   __typename: 'Length'
  //                   // },
  //                   thickness: {
  //                     value: 3,
  //                     unit: 'mm'
  //                     // __typename: 'Thickness'
  //                   },
  //                   // color: 'GREEN',
  //                   __typename: 'CoverPlateProperties'
  //                 },
  //                 elements: {
  //                   edges: testElements(),
  //                   __typename: 'ElementConnection'
  //                 },
  //                 __typename: 'CoverPlate'
  //               }
  //             },
  //             {
  //               // from: 'Q292ZXI6ZmQyMTE1MzUtYjAxYS00NjdlLTg2ZjItNmM3NWE1YWQ4Mzhh',
  //               id:
  //                 'Q292ZXJQbGF0ZUVkZ2U6MTkyY2Y3OTAtMjFjZS00MWNhLTlkM2MtNDIwZTljYjRiMDY4',
  //               // to: 'Q292ZXJQbGF0ZTo5MjlhZDhjNC00ZGNiLTQzOTEtODQ1MC0xZThlMDA1YTVhNjg=',
  //               properties: {
  //                 side: 'back',
  //                 __typename: 'CoverPlateEdgeProperties'
  //               },
  //               __typename: 'CoverPlateEdge',
  //               node: {
  //                 id:
  //                   'Q292ZXJQbGF0ZTo5MjlhZDhjNC00ZGNiLTQzOTEtODQ1MC0xZThlMDA1YTVhNjg=',
  //                 properties: {
  //                   // width: {
  //                   //   value: 0,
  //                   //   unit: 'mm',
  //                   //   __typename: 'Width'
  //                   // },
  //                   // length: {
  //                   //   value: 0,
  //                   //   unit: 'mm',
  //                   //   __typename: 'Length'
  //                   // },
  //                   thickness: {
  //                     value: 3,
  //                     unit: 'mm'
  //                     // __typename: 'Thickness'
  //                   },
  //                   // color: 'GREEN',
  //                   __typename: 'CoverPlateProperties'
  //                 },
  //                 elements: {
  //                   edges: testElements(),
  //                   __typename: 'ElementConnection'
  //                 },
  //                 __typename: 'CoverPlate'
  //               }
  //             }
  //           ],
  //           __typename: 'CoverPlateConnection'
  //         }
  //       }
  //     }
  //   ],
  //   __typename: 'EnclosureConnection'
  // }
}

export default testData
